import React, { FC, useRef } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import ReactPlayer from "react-player/lazy";

// Interface

export interface VideoProps {
  url?: string;
  image?: string;
}

// Styles

const StyledVideo = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    position: relative;
    padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
    border-radius: 8px;
    overflow: hidden;

    .react-player {
      position: absolute;
      top: 0;
      left: 0;
    }

    .react-player__preview {
      img {
        width: 100%;
      }

      svg {
        position: absolute;
      }
    }
  `};
`;

const StyledPlayer = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 aspect ratio (height:width ratio) */

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  `};
`;

// JSX

const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" fill="none">
    <g clipPath="url(#a)">
      <rect width="128" height="128" fill="#D12E26" rx="64" />
      <path
        fill="#fff"
        d="M55.352 40.005a6.67 6.67 0 0 0-2.664.68C50.414 41.797 49 44.05 49 46.57V81.43a6.518 6.518 0 0 0 3.688 5.886A6.64 6.64 0 0 0 55.61 88c1.422 0 2.83-.462 4.015-1.367l22.8-17.43A6.506 6.506 0 0 0 85 64a6.5 6.5 0 0 0-2.575-5.203l-22.8-17.43a6.583 6.583 0 0 0-4.273-1.362Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect width="128" height="128" fill="#fff" rx="64" />
      </clipPath>
    </defs>
  </svg>
);

export const Video: FC<VideoProps> = ({ url, image }) => {
  const ref = useRef(null);

  return (
    // <StyledVideo>
    //    <ReactPlayer
    //     className="react-player"
    //     light={<img src={image?.image?.localFile?.publicUrl} alt="Thumbnail" />}
    //     url={url}
    //     ref={ref}
    //     playIcon={<PlayIcon />}
    //     playing
    //     width="100%"
    //     height="100%"
    //     controls
    //     config={{
    //       youtube: {
    //         playerVars: { rel: 0, modestBranding: 1 },
    //       },
    //     }}
    //   />
    // </StyledVideo>
    <StyledPlayer>
    <iframe
      width="560"
      height="315"
      src={`${url?.replace("https://youtu.be/", "https://www.youtube.com/embed/")}?modestbranding=1&rel=0`}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
    </StyledPlayer>
  );
};

export default Video;
